import { Entity } from '@app/core/model/entities/entity';

export class JMapParameters extends Entity {
  public serverUrl: string;
  public projectId: number;
  public sessionId: number;
  public areCredentialsSet: boolean;

  public toString(): string {
    return this.serverUrl;
  }
}
